// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"60b4e32a","239":"dad65a69","455":"ffa15b35","833":"f53db691","977":"cc93f148"}[chunkId] + ".chunk.js";
};